import React, { useState, useMemo, useEffect } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const columns = [
  { id: "name", label: "Name", sortable: true },
  { id: "email", label: "Email", sortable: true },
  { id: "age", label: "Age", sortable: true, numeric: true },
  { id: "department", label: "Department", sortable: true },
  {
    id: "salary",
    label: "Salary",
    sortable: true,
    numeric: true,
    format: (value) => `$${value.toLocaleString()}`,
  },
];


const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
];

export default function BasicTable({
  data = rows,
  tableColumns = columns,
  onSelectionChange,
  initialSelected = [],   // <-- nyt prop
}) {
  const [searchTerm, ] = useState(""); // setSearchTerm
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("asc");
  const [selectedRows, setSelectedRows] = useState(new Set());


  useEffect(() => {
	console.log('Initial selected rows:', data, initialSelected);
	if (initialSelected.length > 0) {
	  const initialSet = new Set(initialSelected);
	  setSelectedRows(initialSet);
	}
	// eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // <-- tom dependency array = kun ved mount


    const handleSort = (columnId) => {
    const isAsc = orderBy === columnId && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(columnId);
  };

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  };

  const getComparator = (order, orderBy) =>
    order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);

  const handleSelectRow = (rowId) => {
	console.log('Row clicked:', rowId, data[rowId - 1]);
	if (onSelectionChange) {
		onSelectionChange(rowId, data.find((row) => row.id === rowId));
	}
  };
  const filteredAndSortedData = useMemo(() => {
	let filteredData = data;
	if (searchTerm) {
	  filteredData = data.filter((row) =>
		Object.values(row).some((value) =>
		  value.toString().toLowerCase().includes(searchTerm.toLowerCase())
		)
	  );
	}
	if (orderBy) {
	  filteredData = filteredData.slice().sort(getComparator(order, orderBy));
	}
	return filteredData;
	// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchTerm, order, orderBy]);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
			  {tableColumns.map((column) => (
				<TableCell
				  key={column.id}
				  align={column.numeric ? "right" : "left"}
				  sortDirection={orderBy === column.id ? order : false}
				>
				  {column.sortable ? (
					<TableSortLabel
					  active={orderBy === column.id}
					  direction={orderBy === column.id ? order : "asc"}
					  onClick={() => handleSort(column.id)}
					>
					  {column.label}
					</TableSortLabel>
				  ) : (
					column.label
				  )}
				</TableCell>
			  ))}
			</TableRow>
        </TableHead>
        <TableBody>
			{filteredAndSortedData.length > 0 ? (
						  filteredAndSortedData.map((row, index) => {
							const selected = selectedRows.has(row.id);
							return (
							  <TableRow
								key={row.id}
								hover
								selected={selected}
								onClick={() => handleSelectRow(row.id)}   // <-- klik på rækken vælger
								sx={{ cursor: "pointer" }}
							  >
								{tableColumns.map((column) => (
								  <TableCell key={column.id} align={column.numeric ? "right" : "left"}>
									{column.format ? column.format(row[column.id]) : row[column.id]}
								  </TableCell>
								))}
							  </TableRow>
							);
						  })
						) : (
						  <TableRow>
							<TableCell colSpan={tableColumns.length + 1} align="center">
							  <Typography color="textSecondary">No results found</Typography>
							  {searchTerm && (
								<Typography variant="body2" color="textSecondary">
								  for "{searchTerm}"
								</Typography>
							  )}
							</TableCell>
						  </TableRow>
						)}
          {/* {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.calories}</TableCell>
              <TableCell align="right">{row.fat}</TableCell>
              <TableCell align="right">{row.carbs}</TableCell>
              <TableCell align="right">{row.protein}</TableCell>
            </TableRow>
          ))} */}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
